import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';

import { Actions, AppArea, Subjects, Tag } from 'src/graphql/generated/graphql';

export const getFilterConfig = ({
  t,
  tags,
  exclude = {},
}: {
  t: TFunction;
  tags: Tag[];
  exclude?: { tagIds?: boolean };
}) => [
  ...(exclude.tagIds
    ? []
    : [
        {
          id: 'tagIds',
          size: 3,
          type: FilterItemType.Select,
          props: {
            inputProps: {
              placeholder: t('common.tags'),
              variant: 'outlined',
              name: 'tagIds',
              label: t('common.tags'),
            },
            options: tags.map((tag) => ({
              value: tag.id,
              name: tag.name,
            })),
          },
        },
      ]),
  {
    id: 'appArea',
    size: 3,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('permissions.list.filter.app-area'),
        variant: 'outlined',
        name: 'appArea',
        label: t('permissions.list.filter.app-area'),
      },
      options: Object.values(AppArea).map((appArea) => ({
        value: appArea,
        name: appArea,
      })),
    },
  },
  {
    id: 'subject',
    size: 3,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('permissions.list.filter.subject'),
        variant: 'outlined',
        name: 'subject',
        label: t('permissions.list.filter.subject'),
      },
      options: Object.values(Subjects).map((subject) => ({
        value: subject,
        name: subject,
      })),
    },
  },
  {
    id: 'action',
    size: 3,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('permissions.list.filter.action'),
        variant: 'outlined',
        name: 'action',
        label: t('permissions.list.filter.action'),
      },
      options: Object.values(Actions).map((action) => ({
        value: action,
        name: action,
      })),
    },
  },
];
